import api from '../../api/index';
import config from '@/assets/config.json';
const state = {}
const mutations = {

}
const getters = {

}

const actions = {

 MessageList({
  rootState,
  commit
}, opt) {
  return new Promise((resolve, reject) => {
    api.post(`${config.newHttps.api}/merchant/send/log/list`, opt
    ).then(data => {
      if (data.data) {
        resolve(data.data);
      }
    }).catch((err) => {
      console.log(err);
    });
  });
},
 MessageMoney({
  rootState,
  commit
}, opt) {
  return new Promise((resolve, reject) => {
    api.post(`${config.newHttps.api}/merchant/info`, opt
    ).then(data => {
      if (data.data) {
        resolve(data.data);
      }
    }).catch((err) => {
      console.log(err);
    });
  });
},




}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}